/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from "react";
import { Button, Dropdown, Modal, Spinner, Row, Col } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import ReactSelect from "react-select";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import SVG from "react-inlinesvg";
import low from "lowdb";
import LocalStorage from "lowdb/adapters/LocalStorage";
import Swal from "sweetalert2";
import { useHistory } from "react-router-dom";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { DropdownCustomToggler } from "../../../../../../_metronic/_partials/dropdowns";
import { useTranslation } from "react-i18next";
import { ConvertToDateCurrentTimeZone, translateAuto } from "../../../../../../_metronic/_helpers/AtHelper";
const adapter = new LocalStorage("db");
const db = low(adapter);

let controller = new AbortController();

export default function AttachementComp({
  id,
  IsDetailsMode,
  isTruckerDetails,
}) {
  const history = useHistory();
  const [showModalAttachment, setshowModalAttachment] = useState(false);
  const [isLoadingAuth, setisLoadingAuth] = useState(false);
  const [AttachmentViewModel, setAttachmentViewModel] = useState(null);
  const [AttachmentsList, setAttachmentsList] = useState([]);
  const [path, setPath] = useState();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [attachmentsInfo, setAttachmentsInfo] = useState([]);
  const [AttachmentInitObj, setAttachmentInitObj] = useState({
    shipmentId: "",
    TypeId: "",
    isPublic: false,
    names: [],
  });
  const { t } = useTranslation();

  function GetAttachmentViewModel() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/attachments/GetViewModel`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          console.log("data", data);
          setAttachmentViewModel(data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }
  function GetAttachments() {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/attachments/shipment/${id}`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setAttachmentsList(data);
        } else if (result[0] === 401) {
          history.push("/logout");
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function GetAttachmentPath(id) {
    var myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${db.read().getState()?.Token}`);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${window.$apiurl}/api/Attachments/${id}`, requestOptions)
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then(async (result) => {
        if (result[0] === 200) {
          var data = result[1];
          setAttachmentsInfo(data);
          setPath(data.Attachment.FilePath);
          if (
            data.Attachment.FileName.includes(".jpg") ||
            data.Attachment.FileName.includes(".png") ||
            data.Attachment.FileName.includes(".jpeg")
          ) {
            handleShow();
          } else {
            window.open(data.Attachment.FilePath, "_blank");
          }
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  }

  function PutAttachments() {
    setisLoadingAuth(true);
    var formdata = new FormData();
    acceptedFiles.map((file) => {
      formdata.append("File", file, file.name);
      return false;
    });
    return fetch(
      `${window.$apiurl}/api/Attachments/${AttachmentInitObj.Id}?name=${AttachmentInitObj.FileName}&typeId=${AttachmentInitObj.TypeId}`, //&names[0]={names[0]}&names[1]={names[1]}
      {
        method: "Put",
        body: formdata,
        redirect: "follow",
        withCredentials: true,
        headers: {
          Authorization: `bearer ${db.read().getState().Token}`,
          "X-FP-API-KEY": "iphone",
        },
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          acceptedFiles.length = 0;
          acceptedFiles.splice(0, acceptedFiles.length);
          setshowModalAttachment(false);
          GetAttachments();
        } else {
          if (
            result[1].ModelState !== null &&
            result[1].ModelState !== undefined &&
            result[1].ModelState !== ""
          ) {
            let modelState = result[1].ModelState;
            if (modelState)
              Object.keys(modelState).forEach(function(k) {
                modelState[k].forEach((element) => {
                  Swal.fire(translateAuto("Error"), translateAuto(element) , "error");
                });
              });
          } else if (
            result[1].Message !== null &&
            result[1].Message !== undefined &&
            result[1].Message !== ""
          ) {
            Swal.fire(translateAuto("Error"), translateAuto(result[1].Message), "error");
          } else if (
            result[1].error_description !== null &&
            result[1].error_description !== undefined &&
            result[1].error_description !== ""
          ) {
            Swal.fire(translateAuto("Error"), result[1].error_description);
          } else {
            Swal.fire(translateAuto("Error"), translateAuto("Bad_request"), "error");
          }
        }
        setisLoadingAuth(false);
      })
      .catch((error) => {
        Swal.fire(translateAuto("Error"), translateAuto(error), "error");
        setisLoadingAuth(false);
      });
  }
  function PostAttachments() {
    var sizedata = 0;
    var isFileLimit = false;
    var formdata = new FormData();
    acceptedFiles.map((file) => {
      formdata.append("File", file, file.name);
      sizedata = sizedata + file.size;
      if (file.size > 5000000) {
        isFileLimit = true;
      }
      return false;
    });
    const signal = controller.signal;
    if (
      AttachmentInitObj.TypeId === "" ||
      AttachmentInitObj.TypeId === undefined ||
      AttachmentInitObj.TypeId === null
    ) {
      Swal.fire(t("Error"), t("Please_select_attachment_type"));
      return false;
    }
    if (isFileLimit) {
      Swal.fire(t("Error"), t("You_have_exceeded_the_file_size_limit(5mb)"));
      return false;
    }
    if (sizedata > 20000000) {
      Swal.fire(t("Error"), t("You_have_exceeded_the_size_limit(20mb)"));
      return;
    }
    setisLoadingAuth(true);

    return fetch(
      `${window.$apiurl}/api/Attachments?shipmentId=${id}&typeId=${AttachmentInitObj.TypeId}&isPublic=${AttachmentInitObj.isPublic}`, //&names[0]={names[0]}&names[1]={names[1]}
      {
        method: "POST",
        body: formdata,
        redirect: "follow",
        signal: signal,
        withCredentials: true,
        headers: {
          Authorization: `bearer ${db.read().getState().Token}`,
          "X-FP-API-KEY": "iphone",
        },
      }
    )
      .then(async (response) => {
        const statusCode = await response.status;
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.indexOf("application/json") !== -1) {
          return response.json().then((data) => [statusCode, data]);
        } else {
          return response.text().then((text) => [statusCode, { Message: "" }]);
        }
      })
      .then((result) => {
        if (result[0] === 200) {
          acceptedFiles.length = 0;
          acceptedFiles.splice(0, acceptedFiles.length);
          setshowModalAttachment(false);
          GetAttachments();
        } else {
          if (
            result[1].ModelState !== null &&
            result[1].ModelState !== undefined &&
            result[1].ModelState !== ""
          ) {
            let modelState = result[1].ModelState;
            if (modelState)
              Object.keys(modelState).forEach(function(k) {
                modelState[k].forEach((element) => {
                  Swal.fire(translateAuto("Error"), translateAuto(element), "error");
                });
              });
          } else if (
            result[1].Message !== null &&
            result[1].Message !== undefined &&
            result[1].Message !== ""
          ) {
            Swal.fire(translateAuto("Error"), translateAuto(result[1].Message) , "error");
          } else if (
            result[1].error_description !== null &&
            result[1].error_description !== undefined &&
            result[1].error_description !== ""
          ) {
            Swal.fire(translateAuto("Error"), translateAuto(result[1].error_description) , "error");
          } else {
            Swal.fire(translateAuto("Error"), translateAuto("Bad_request"), "error");
          }
        }
        setisLoadingAuth(false);
      })
      .catch((error) => {
        if (error.name === "AbortError") {
          Swal.fire(t("Error"), t("The_request_is_aborted"));
          setisLoadingAuth(false);
        } else {
          Swal.fire(t("Error"), error);
          setisLoadingAuth(false);
        }
      });
  }
  useEffect(() => {
    GetAttachmentViewModel();
    GetAttachments();
  }, [id]);

  const baseStyle = {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "100px",
    borderWidth: 2,
    borderRadius: 2,
    borderColor: "#3699FF",
    borderStyle: "dashed",
    backgroundColor: "#fafafa",
    color: "#464E5F",
    outline: "none",
    transition: "border .24s ease-in-out",
  };
  const activeStyle = {
    borderColor: "#2196f3",
  };

  const acceptStyle = {
    borderColor: "#00e676",
  };

  const rejectStyle = {
    borderColor: "#ff1744",
  };
  const { isDragActive, isDragAccept, isDragReject } = useDropzone({
    accept: "image/*",
  });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [
      baseStyle,
      isDragActive,
      isDragReject,
      isDragAccept,
      activeStyle,
      acceptStyle,
      rejectStyle,
    ]
  );
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone();
  const files = acceptedFiles.map((file,index) => (
    <React.Fragment key={String(index)}>
      <li>
        <strong>{file.path}</strong> - {file.size} bytes
      </li>
    </React.Fragment>
  ));

  return (
    <>
      <Card>
        <CardHeader title={t("Attachments")}>
          <CardHeaderToolbar>
            {!IsDetailsMode && (
              <button
                type="button"
                className="btn btn-success mr-4"
                onClick={() => {
                  setAttachmentInitObj({
                    shipmentId: "",
                    TypeId: "",
                    isPublic: false,
                    names: [],
                  });
                  setshowModalAttachment(true);
                }}
              >
                <i className="fas fa-plus mr-3" />
                {t("Add_Attachment")}
              </button>
            )}
          </CardHeaderToolbar>
        </CardHeader>
        <CardBody>
          <div className="row">
            {AttachmentsList.map((items, index) => {
              let extention = items.FileName?.split(".").pop();
              return (
                  <React.Fragment key={String(index)}>
                    <div
                      className={
                        isTruckerDetails
                          ? "col-xl-6 col-lg-6 col-md-6 col-sm-6"
                          : "col-xl-3 col-lg-6 col-md-6 col-sm-6"
                      }
                    >
                      {/*begin::Card*/}
                      <div className="card card-custom gutter-b card-stretch shadow-sm  bg-gray-100">
                        {items.IsOwner && !IsDetailsMode && (
                          <div className="card-header border-0">
                            <h3 className="card-title">
                              <span className="switch switch-outline switch-brand">
                                <label className="checkbox checkbox-success">
                                  <input
                                    type="checkbox"
                                    name="Checkboxes5"
                                    checked={items?.IsPublic}
                                    onChange={() => {
                                      setisLoadingAuth(true);

                                      return fetch(
                                        `${window.$apiurl}/api/attachments/Visibility/${items.Id}`, //&names[0]={names[0]}&names[1]={names[1]}
                                        {
                                          method: "Put",
                                          redirect: "follow",
                                          withCredentials: true,
                                          headers: {
                                            Authorization: `bearer ${
                                              db.read().getState().Token
                                            }`,
                                            "X-FP-API-KEY": "iphone",
                                          },
                                        }
                                      )
                                        .then(async (response) => {
                                          const statusCode = await response.status;
                                          const contentType = response.headers.get(
                                            "content-type"
                                          );
                                          if (
                                            contentType &&
                                            contentType.indexOf(
                                              "application/json"
                                            ) !== -1
                                          ) {
                                            return response
                                              .json()
                                              .then((data) => [
                                                statusCode,
                                                data,
                                              ]);
                                          } else {
                                            return response
                                              .text()
                                              .then((text) => [
                                                statusCode,
                                                { Message: "" },
                                              ]);
                                          }
                                        })
                                        .then((result) => {
                                          if (result[0] === 200) {
                                            GetAttachments();
                                          } else {
                                            if (
                                              result[1].ModelState !== null &&
                                              result[1].ModelState !==
                                                undefined &&
                                              result[1].ModelState !== ""
                                            ) {
                                              let modelState =
                                                result[1].ModelState;
                                              if (modelState)
                                                Object.keys(modelState).forEach(
                                                  function(k) {
                                                    modelState[k].forEach(
                                                      (element) => {
                                                        Swal.fire(
                                                          translateAuto("Error"),
                                                          translateAuto(element),
                                                          "error"
                                                        );
                                                      }
                                                    );
                                                  }
                                                );
                                            } else if (
                                              result[1].Message !== null &&
                                              result[1].Message !== undefined &&
                                              result[1].Message !== ""
                                            ) {
                                              Swal.fire(
                                                translateAuto("Error"),
                                                translateAuto(result[1].Message),
                                                "error"
                                              );
                                            } else if (
                                              result[1].error_description !==
                                                null &&
                                              result[1].error_description !==
                                                undefined &&
                                              result[1].error_description !== ""
                                            ) {
                                              Swal.fire(
                                                translateAuto("Error"),
                                                translateAuto(result[1].error_description),
                                                "error"
                                              );
                                            } else {
                                              Swal.fire(
                                                translateAuto("Error"),
                                                translateAuto("Bad_request")
                                              );
                                            }
                                          }
                                          setisLoadingAuth(false);
                                        })
                                        .catch((error) => {
                                          Swal.fire(t("Error"), translateAuto(error), "error");
                                          setisLoadingAuth(false);
                                        });
                                    }}
                                  />
                                  <span className="mr-2" />
                                  {items?.IsPublic ? t("Public") : t("Private")}
                                </label>
                              </span>
                            </h3>
                            <div className="card-toolbar">
                              <Dropdown
                                className="dropdown-inline position-unset"
                                alignRight
                              >
                                <Dropdown.Toggle
                                  as={DropdownCustomToggler}
                                  id="dropdown-toggle-top"
                                >
                                  <i className="ki ki-bold-more-hor" />
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                                  <ul className="navi navi-hover py-5">
                                    <li className="navi-item">
                                      <p
                                        className="navi-link"
                                        onClick={() => {
                                          var myHeaders = new Headers();
                                          myHeaders.append(
                                            "Authorization",
                                            `Bearer ${
                                              db.read().getState()?.Token
                                            }`
                                          );

                                          var requestOptions = {
                                            method: "GET",
                                            headers: myHeaders,
                                            redirect: "follow",
                                          };

                                          fetch(
                                            `${window.$apiurl}/api/Attachments/${items.Id}`,
                                            requestOptions
                                          )
                                            .then(async (response) => {
                                              const statusCode = await response.status;
                                              const contentType = response.headers.get(
                                                "content-type"
                                              );
                                              if (
                                                contentType &&
                                                contentType.indexOf(
                                                  "application/json"
                                                ) !== -1
                                              ) {
                                                return response
                                                  .json()
                                                  .then((data) => [
                                                    statusCode,
                                                    data,
                                                  ]);
                                              } else {
                                                return response
                                                  .text()
                                                  .then((text) => [
                                                    statusCode,
                                                    { Message: "" },
                                                  ]);
                                              }
                                            })
                                            .then(async (result) => {
                                              if (result[0] === 200) {
                                                var data = result[1];
                                                setAttachmentInitObj(
                                                  data?.Attachment
                                                );
                                                setshowModalAttachment(true);
                                              }
                                            })
                                            .catch((error) => {
                                              console.log("error", error);
                                            });
                                        }}
                                      >
                                        <span className="svg-icon svg-icon-md svg-icon-primary mr-2">
                                          <SVG
                                            src={toAbsoluteUrl(
                                              "/media/svg/icons/Communication/Write.svg"
                                            )}
                                          />
                                        </span>

                                        <span className="navi-text">
                                          {t("Edit")}
                                        </span>
                                      </p>
                                    </li>
                                    <li className="navi-item">
                                      <p
                                        className="navi-link"
                                        onClick={() => {
                                          Swal.fire({
                                            title: t("Are_you_sure"),
                                            text: t(
                                              "You_wont_be_able_to_revert_this"
                                            ),
                                            icon: "warning",
                                            showCancelButton: true,
                                            confirmButtonColor: "#3085d6",
                                            cancelButtonColor: "#d33",
                                            confirmButtonText: t(
                                              "Yes_delete_it"
                                            ),
                                          }).then((result) => {
                                            if (result.isConfirmed) {
                                              var myHeaders = new Headers();
                                              myHeaders.append(
                                                "Authorization",
                                                `Bearer ${
                                                  db.read().getState()?.Token
                                                }`
                                              );
                                              myHeaders.append(
                                                "Content-Type",
                                                "application/json"
                                              );

                                              var requestOptions = {
                                                method: "delete",
                                                headers: myHeaders,
                                                redirect: "follow",
                                              };

                                              fetch(
                                                `${window.$apiurl}/api/Attachments/${items.Id}`,
                                                requestOptions
                                              )
                                                .then(async (response) => {
                                                  const statusCode = await response.status;
                                                  const contentType = response.headers.get(
                                                    "content-type"
                                                  );
                                                  if (
                                                    contentType &&
                                                    contentType.indexOf(
                                                      "application/json"
                                                    ) !== -1
                                                  ) {
                                                    return response
                                                      .json()
                                                      .then((data) => [
                                                        statusCode,
                                                        data,
                                                      ]);
                                                  } else {
                                                    return response
                                                      .text()
                                                      .then((text) => [
                                                        statusCode,
                                                        { Message: "" },
                                                      ]);
                                                  }
                                                })
                                                .then(async (result) => {
                                                  if (result[0] === 200) {
                                                    Swal.fire(
                                                      t("Deleted"),
                                                      t(
                                                        "Your_Attachment_has_been_deleted"
                                                      ),
                                                      "success"
                                                    );
                                                    GetAttachments();
                                                  } else {
                                                    if (
                                                      result[1].ModelState !==
                                                        null &&
                                                      result[1].ModelState !==
                                                        undefined &&
                                                      result[1].ModelState !==
                                                        ""
                                                    ) {
                                                      let modelState =
                                                        result[1].ModelState;
                                                      if (modelState)
                                                        Object.keys(
                                                          modelState
                                                        ).forEach(function(k) {
                                                          modelState[k].forEach(
                                                            (element) => {
                                                              Swal.fire(
                                                                "Oops!",
                                                                translateAuto(element),
                                                                "error"
                                                              );
                                                            }
                                                          );
                                                        });
                                                    } else if (
                                                      result[1].Message !==
                                                        null &&
                                                      result[1].Message !==
                                                        undefined &&
                                                      result[1].Message !== ""
                                                    ) {
                                                      Swal.fire(
                                                        "Oops!",
                                                        translateAuto(result[1].Message),
                                                        "error"
                                                      );
                                                    } else if (
                                                      result[1]
                                                        .error_description !==
                                                        null &&
                                                      result[1]
                                                        .error_description !==
                                                        undefined &&
                                                      result[1]
                                                        .error_description !==
                                                        ""
                                                    ) {
                                                      Swal.fire(
                                                        "Oops!",
                                                        translateAuto(result[1].error_description),
                                                        "error"
                                                      );
                                                    } else {
                                                      Swal.fire(
                                                        "Oops!",
                                                        translateAuto("Bad_request"),
                                                        "error"
                                                      );
                                                    }
                                                  }
                                                })
                                                .catch((error) => {
                                                  console.log("error", error);
                                                });
                                            }
                                          });
                                        }}
                                      >
                                        <span className="svg-icon svg-icon-md svg-icon-danger mr-2">
                                          <SVG
                                            src={toAbsoluteUrl(
                                              "/media/svg/icons/General/Trash.svg"
                                            )}
                                          />
                                        </span>
                                        <span className="navi-text">
                                          {t("Delete")}
                                        </span>
                                      </p>
                                    </li>
                                  </ul>
                                </Dropdown.Menu>
                              </Dropdown>
                            </div>
                          </div>
                        )}

                        <div className="card-body">
                          <div className="d-flex flex-column align-items-center">
                            {/*begin: Icon*/}
                            <img
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                GetAttachmentPath(items.Id);
                                // let types = ["svg", "jpg", "png"];
                                // if(types.some(el => items.FilePath.includes(el))){
                                //   setPath(items.FilePath);
                                //   handleShow();
                                // }else{
                                //   window.open(items.FilePath, "_blank");
                                // }
                                // e.preventDefault();
                              }}
                              alt="logo"
                              className="max-h-65px"
                              src={`/media/svg/files/${
                                String(extention).includes("pdf")
                                  ? "pdf"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("xml")
                                  ? "xml"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("tif")
                                  ? "tif"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("sql")
                                  ? "sql"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("doc")
                                  ? "doc"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("css")
                                  ? "css"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("pdf")
                                  ? "pdf"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("ai")
                                  ? "ai"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("xls")
                                  ? "xls"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("png")
                                  ? "png"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("jpg")
                                  ? "jpg"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("jpeg")
                                  ? "jpg"
                                  : String(extention)
                                      .toLocaleLowerCase()
                                      .includes("csv")
                                  ? "csv"
                                  : "text"
                              }.svg`}
                            />

                            <p
                              onClick={(e) => {
                                GetAttachmentPath(items.Id);
                              }}
                              rel="noopener noreferrer"
                              className="text-dark-75 font-weight-bold mt-3 font-size-lg w-100 text-center"
                            >
                              {items.FileName}
                            </p>
                            <span className="navi-text text-muted">
                              {items?.Type}
                            </span>
                            <span className="navi-text text-muted">
                              {ConvertToDateCurrentTimeZone(items.Created)}
                            </span>
                            {/*end: Tite*/}
                          </div>
                        </div>
                      </div>
                      {/*end:: Card*/}
                    </div>
                  </React.Fragment>
              );
            })}
          </div>
        </CardBody>
      </Card>
      <Modal
        size="xl"
        show={showModalAttachment}
        onHide={() => {
          setshowModalAttachment(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {AttachmentInitObj.Id !== undefined
              ? `${t("Edit_Attachment")}` +" "+ AttachmentInitObj?.FileName
              : `${t("Add_Attachment")}`}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            {AttachmentInitObj.Id === undefined && (
              <div className="col-md-12" style={{ width: "100%" }}>
                <div {...getRootProps({ style })}>
                  <input {...getInputProps()} />
                  <svg
                    aria-hidden="true"
                    focusable="false"
                    className="uppy-c-icon uppy-DragDrop-arrow"
                    width="40"
                    height="40"
                    viewBox="0 0 16 16"
                  >
                    <path
                      d="M11 10V0H5v10H2l6 6 6-6h-3zm0 0"
                      fill-rule="evenodd"
                    ></path>
                  </svg>
                  <div className="uppy-DragDrop-label">
                    {t("Drop_files_here_or")}{" "}
                    <span className="uppy-DragDrop-browse">{t("browse")}</span>
                  </div>
                </div>
                <aside>
                  <h4 className="pt-5">{t("Files")}</h4>
                  <ul>{files}</ul>
                </aside>
              </div>
            )}
            <div className="col-md-6">
              <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                <p className="text-dark font-weight-bold text-hover-primary mb-1 font-size-lg">
                  {t("Attachment_Type")}
                  <span className="text-danger">*</span>
                </p>
                <span className="font-weight-bold">
                  <ReactSelect
                    name="type"
                    id="type"
                    label="type"
                    value={AttachmentViewModel?.attachmentTypes
                      ?.filter((a) => a.Id === AttachmentInitObj.TypeId)
                      ?.map((a) => {
                        return { label: a.Name, value: a.Id };
                      })}
                    options={AttachmentViewModel?.attachmentTypes?.map((a) => {
                      return { label: a.Name, value: a.Id };
                    })}
                    onChange={(e) => {
                      let obj = { ...AttachmentInitObj };
                      obj.TypeId = e.value;
                      setAttachmentInitObj(obj);
                    }}
                  />
                </span>
              </div>
            </div>
            {AttachmentInitObj.Id !== undefined ? (
              <div className="col-md-6">
                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                  <p className="text-dark font-weight-bold text-hover-primary mb-1 font-size-lg">
                    {t("File_Name")}
                    <span className="text-danger">*</span>
                  </p>
                  <span className="font-weight-bold">
                    <div className="input-group">
                      <input
                        type="text"
                        onChange={(e) => {
                          let obj = { ...AttachmentInitObj };
                          obj.FileName =
                            e.target.value +
                            "." +
                            AttachmentInitObj.FileName?.split(".").pop();
                          setAttachmentInitObj(obj);
                        }}
                        value={AttachmentInitObj.FileName?.replace(
                          /\.[^/.]+$/,
                          ""
                        )}
                        className="form-control"
                        placeholder={t("File_Name")}
                      />
                      <div className="input-group-append">
                        <button className="btn btn-secondary" type="button">
                          {AttachmentInitObj.FileName?.split(".").pop()}
                        </button>
                      </div>
                    </div>
                    {/* <input
                      type="text"
                      className="form-control  form-control-lg"
                      value={AttachmentInitObj?.FileName}
                      onChange={(e) => {
                        let obj = { ...AttachmentInitObj };
                        obj.FileName = e.target.value;
                        setAttachmentInitObj(obj);
                      }}
                      name="Name"
                    /> */}
                  </span>
                </div>
              </div>
            ) : (
              <div className="col-md-6">
                <div className="d-flex flex-column flex-grow-1 my-lg-0 my-2 mr-2">
                  <p className="text-dark font-weight-bold text-hover-primary mb-1 font-size-lg">
                    {t("Access_Level")}
                    <span className="text-danger">*</span>
                  </p>
                  <span className="font-weight-bold">
                    <ReactSelect
                      name="AccessLevel"
                      id="AccessLevel"
                      label="AccessLevel"
                      value={[
                        { label: "Public", value: true },
                        { label: "Private", value: false },
                      ].filter((a) => a.value === AttachmentInitObj.isPublic)}
                      options={[
                        { label: "Public", value: true },
                        { label: "Private", value: false },
                      ]}
                      onChange={(e) => {
                        let obj = { ...AttachmentInitObj };
                        obj.isPublic = e.value;
                        setAttachmentInitObj(obj);
                      }}
                      inputId="react-select-single"
                    />
                  </span>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setshowModalAttachment(false);
              controller.abort();
              controller = new AbortController();
            }}
          >
            {t("Close")}
          </Button>
          <Button
            variant="primary"
            disabled={isLoadingAuth}
            onClick={() => {
              if (AttachmentInitObj.Id !== undefined) {
                PutAttachments();
              } else {
                PostAttachments();
              }
            }}
          >
            {t("Confirm")}
            {isLoadingAuth && (
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ########################Open attachments ####################### */}
      <Modal size="lg" show={show} onHide={handleClose} animation={false}>
        <Modal.Body className="pb-0">
          <Row className="mb-6">
            <Col>
              <div className="d-flex flex-column font-weight-bold">
                {/*eslint-disable */}
                <a className="text-muted text-hover-primary mb-1 font-size-lg">
                  {t("Uploaded_at")}
                </a>
                <span className="text-dark font-weight-bold">
                  {ConvertToDateCurrentTimeZone(attachmentsInfo?.Attachment?.Created)}
                </span>
              </div>
            </Col>
            <Col>
              <div className="d-flex flex-column font-weight-bold">
                <a className="text-muted text-hover-primary mb-1 font-size-lg">
                  {t("Type")}
                </a>
                <span className="text-dark">
                  {attachmentsInfo?.Attachment?.Type}
                </span>
              </div>
            </Col>
            <Col>
              <div className="d-flex flex-column font-weight-bold">
                <a className="text-muted text-hover-primary mb-1 font-size-lg">
                  {t("File_Name")}
                </a>
                <span className="text-dark">
                  {" "}
                  {attachmentsInfo?.Attachment?.FileName?.length > 25
                    ? attachmentsInfo?.Attachment?.FileName?.substring(0, 25) +
                      "..."
                    : attachmentsInfo?.Attachment?.FileName}
                </span>
              </div>
            </Col>
          </Row>
          <Row>
            <img
              style={{ maxWidth: "100%", height: "auto" }}
              src={path}
              alt={attachmentsInfo?.Attachment?.FilePath || ""}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t("Close")}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
